enum DomainAvailabilityReason {
  None = "NONE",
  DomainUnavailable = "DOMAIN_TAKEN",
  TldNotAllowed = "TLD_NOT_ALLOWED",
}

enum DomainOrderStatus {
  CREATED = "CREATED",
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PAID = "PAID",
  PURCHASING = "PURCHASING",
  PURCHASED = "PURCHASED",
  DOMAIN_TAKEN = "DOMAIN_TAKEN",
  PURCHASE_FAILED = "PURCHASE_FAILED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
  EXPIRED = "EXPIRED",
}

enum DomainLifecycleStatus {
  REGISTERING_DOMAIN = "REGISTERING_DOMAIN",
  PENDING_EMAIL_VERIFICATION = "PENDING_EMAIL_VERIFICATION",
  ACTIVE = "ACTIVE",
  EXPIRING_SOON = "EXPIRING_SOON",
  RENEWAL_REQUIRED = "RENEWAL_REQUIRED",
}

export { DomainAvailabilityReason, DomainOrderStatus, DomainLifecycleStatus };
